
import { ResponseDataGet } from "../../../../models/responseDataGet";
import { EntAnaliticalDataTLCFilter, StatusTLCData, RegionTLCData , EntTLC } from "./types"
import { agroApi } from "../../../../redux/api/api";
export const analiticalDataTLCOrganicApi = agroApi.injectEndpoints({
  endpoints: (builder) => ({


    getAnaliticalDataStatusTLCList: builder.query<ResponseDataGet<StatusTLCData>, EntAnaliticalDataTLCFilter>({
  query: (filter) => ({
        url: "/departments/organic/logistics-center/analytical-data/status",
        method: "POST",
        body: JSON.stringify(filter)
      }),
    }),
    getAnaliticalDataCapacityTLCList: builder.query<ResponseDataGet<RegionTLCData>, EntAnaliticalDataTLCFilter>({
      query: (filter) => ({
            url: "/departments/organic/logistics-center/analytical-data/capacity",
            method: "POST",
            body: JSON.stringify(filter)
          }),
        }),
        getAllDataOfTLCList: builder.query<ResponseDataGet<EntTLC>, EntAnaliticalDataTLCFilter>({
          query: (filter) => ({
                url: "/departments/organic/logistics-center/get-all",
                method: "POST",
                body: JSON.stringify(filter)
              }),
            }),
  }),
  overrideExisting: false,
});

export const {
    useGetAnaliticalDataStatusTLCListQuery,
    useGetAnaliticalDataCapacityTLCListQuery,
    useGetAllDataOfTLCListQuery,
} = analiticalDataTLCOrganicApi;
